var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMinus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M-1-1h36v36H-1z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#453c90",
    strokeWidth: 1.5,
    cx: 16.75,
    cy: 17.227,
    stroke: "#453c90",
    r: 16
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 1.5,
    strokeLinejoin: "null",
    strokeLinecap: "null",
    stroke: "#fff",
    d: "M11 18.703h10.25"
  }))));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzQiIGhlaWdodD0iMzQiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiA8IS0tIENyZWF0ZWQgd2l0aCBNZXRob2QgRHJhdyAtIGh0dHA6Ly9naXRodWIuY29tL2R1b3BpeGVsL01ldGhvZC1EcmF3LyAtLT4KCiA8Zz4KICA8dGl0bGU+YmFja2dyb3VuZDwvdGl0bGU+CiAgPHJlY3QgeD0iLTEiIHk9Ii0xIiB3aWR0aD0iMzYiIGhlaWdodD0iMzYiIGlkPSJjYW52YXNfYmFja2dyb3VuZCIgZmlsbD0ibm9uZSIvPgogPC9nPgogPGc+CiAgPHRpdGxlPkxheWVyIDE8L3RpdGxlPgogIDxlbGxpcHNlIGZpbGw9IiM0NTNjOTAiIHN0cm9rZS13aWR0aD0iMS41IiBjeD0iMTYuNzUiIGN5PSIxNy4yMjY1NiIgaWQ9InN2Z18yIiByeD0iMTUuOTk5ODIiIHJ5PSIxNS45OTk4MiIgc3Ryb2tlPSIjNDUzYzkwIi8+CiAgPGxpbmUgZmlsbD0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxLjUiIHgxPSIxMC45OTk5OCIgeTE9IjE4LjcwMzExIiB4Mj0iMjEuMjUwMSIgeTI9IjE4LjcwMzExIiBpZD0ic3ZnXzMiIHN0cm9rZS1saW5lam9pbj0ibnVsbCIgc3Ryb2tlLWxpbmVjYXA9Im51bGwiIHN0cm9rZT0iI2ZmZmZmZiIvPgogPC9nPgo8L3N2Zz4=";
export { SvgMinus as ReactComponent };